import type React from "react";
import "./style.css";

export const Footer: React.FC = () => {
	return (
		<footer className="t4-footer  flex flex-col justify-end md:flex-row md:justify-between md:flex-row-reverse md:items-end md:px-20">
			<nav className="footer-nav flex basis-1 md:basis-2">
				<a
					href="https://web.auto/contact/"
					target="_blank"
					rel="noopener noreferrer"
				>
					CONTACT
				</a>
				<a
					href="https://tier4.jp/privacy/"
					target="_blank"
					rel="noopener noreferrer"
				>
					PRIVACY
				</a>
				<a href="/terms" target="_blank" rel="noopener noreferrer">
					TERMS
				</a>
			</nav>
			<p className="text-center md:text-left mt-8 md:mt-0">
				&copy; TIER IV, INC.
			</p>
		</footer>
	);
};
